import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import { firebase, getAuth } from "../helper/helperFirebaseAuth";
import { apiPost } from '../helper/helperApi';
import MainLogo from './../components/mainLogo';
import SupportToast from './../components/supportToast';
import ComLoading from './../components/comLoading';
import { handleException } from '../helper/helperError';

const PageSignIn = () => {
    const [isloading, setIsLoading] = React.useState(false);
    const location = useLocation();
    const urlFrom = location.state?.from?.pathname || "/";
    const urlWebsite = import.meta.env.VITE_URL_WEB || "https://sparklingemail.com";

    const handleSignInSuccess = async (_authResult) => {
        try {
            setIsLoading(true);
            apiPost("/auth/signin");
            return true;
        } catch (ex) {
            handleException(ex, "Sign-in Error", "There was an error signing in. Please try again later.");
            return false;
        }
    };

    React.useEffect(() => {
        const auth = getAuth();
        const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
        const uiConfig = {
            signInFlow: "popup",
            signInSuccessUrl: urlFrom || "/",
            signInOptions: [
                'microsoft.com',
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                'yahoo.com',
            ],
            tosUrl: `${urlWebsite}/terms`,
            privacyPolicyUrl: `${urlWebsite}/privacy`,
            callbacks: { signInSuccessWithAuthResult: handleSignInSuccess, },
        };

        ui.start("#firebaseui-auth-container", uiConfig);

        // cleanup function to reset the UI instance
        return () => ui.reset();
    }, []);

    return <>
        <Helmet>
            <title>Sign In | Sparkling Email Dashboard</title>
            <meta name="description" content="Login to Sparkling Email to access your account and manage your services." />
        </Helmet>

        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <header className="text-center mb-8">
                    <Link to={urlWebsite} className="inline-flex items-center space-x-2 mb-4">
                        <MainLogo />
                        <span className="text-xl font-bold bg-gradient-to-r bg-clip-text text-transparent animate-gradient from-blue-600 via-teal-600 to-yellow-400">
                            Sparkling Email
                        </span>
                    </Link>
                    <p className="text-slate-600 text-sm">Welcome! Please sign in to continue.</p>
                </header>

                <main className="bg-white/60 backdrop-blur-sm shadow-xs rounded-lg p-8 border border-slate-200">
                    <div className="text-center mb-6">
                        <h1 className="text-2xl font-semibold text-slate-900">Sign In</h1>
                        <p className="text-slate-600 pt-2 text-sm">
                            Choose your preferred provider to continue
                        </p>
                    </div>
                    <div id="firebaseui-auth-container" />
                    {isloading && <ComLoading />}
                </main>

                <footer className="text-center mt-6 text-xs text-slate-500 leading-relaxed">
                    By signing in, you agree to our{' '}
                    <Link to={`${urlWebsite}/terms`} className="text-blue-600 hover:underline">Terms of Service</Link>
                    {' '}and{' '}
                    <Link to={`${urlWebsite}/privacy`} className="text-blue-600 hover:underline">Privacy Policy</Link>.
                </footer>
                <SupportToast className="mt-6" />
            </div>
        </div>

    </>
};

export default PageSignIn;